import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';

@Injectable()
export class CameraService extends BaseApiService {

  get currentCameraUserId(): string {
    return localStorage.getItem('currentCameraUserId');
  }

  set currentCameraUserId(id: string) {
    localStorage.setItem('currentCameraUserId', id);
  }
  constructor(
    private apiCallService: ApiCallService
  ) {
    super();
  }

  moveRelative(id: number, direction: string, camera_user_uuid: string): Promise<any> {
    this.validateId(id, 'id');
    return this.apiCallService.post(
      '/cameras/' + id + '/camera_control/move_relative',
      {
        direction: direction,
        camera_user_uuid: camera_user_uuid
     },
      undefined);
  }

  moveContinuous(id: number, direction: string, camera_user_uuid: string): Promise<any> {
    this.validateId(id, 'id');
    return this.apiCallService.post(
      '/cameras/' + id + '/camera_control/move_continuous',
      {
        direction: direction,
        camera_user_uuid: camera_user_uuid
     },
      undefined);
  }

  moveStop(id: number, camera_user_uuid: string): Promise<any> {
    this.validateId(id, 'id');
    return this.apiCallService.post(
      '/cameras/' + id + '/camera_control/move_stop',
      { camera_user_uuid: camera_user_uuid },
      undefined);
  }

  requestControl(id: number, data: any): Promise<any> {
    this.validateId(id, 'id');
    return this.apiCallService.post('/cameras/' + id + '/camera_control', data);
  }

  checkQueueStatus(id: number, camera_user_uuid: string): Promise<any> {
    return this.apiCallService.post(
      '/cameras/' + id + '/camera_control/check', {
        camera_user_uuid: camera_user_uuid
      }
    );
  }

  leaveQueue(id: number, camera_user_uuid: string): Promise<any> {
    return this.apiCallService.delete('/cameras/' + id + '/camera_control', {
      camera_user_uuid: camera_user_uuid
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/camera.service.ts